/* unplugin-vue-components disabled */import { render } from "./share-skeleton.vue?vue&type=template&id=60d77160&scoped=true"
const script = {}

import "./share-skeleton.vue?vue&type=style&index=0&id=60d77160&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d77160"],['__file',"src/pages/share-chat/share-skeleton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60d77160"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60d77160', __exports__)) {
    api.reload('60d77160', __exports__)
  }
  
  module.hot.accept("./share-skeleton.vue?vue&type=template&id=60d77160&scoped=true", () => {
    api.rerender('60d77160', render)
  })

}


export default __exports__